import {Id} from '../../types';

export class MediaOrderingRequest {
  ids: Id[];

  constructor(ids: Id[]) {
    this.ids = ids;
  }
}
